export default require('../../lang/vi-VN.po')
